module.exports = __webpack_public_path__ + "static/media/info.694bd258.png";